import { render, staticRenderFns } from "./fr-FR.vue?vue&type=template&id=9ce5c248&"
import script from "./fr-FR.vue?vue&type=script&lang=js&"
export * from "./fr-FR.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9ce5c248')) {
      api.createRecord('9ce5c248', component.options)
    } else {
      api.reload('9ce5c248', component.options)
    }
    module.hot.accept("./fr-FR.vue?vue&type=template&id=9ce5c248&", function () {
      api.rerender('9ce5c248', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/Languages/fr-FR.vue"
export default component.exports